import React from 'react';
import { Button, cn } from '@mf-tools/domains-ui';
import { scrollToId } from '../lib/scroll';
import { Container } from '../components';

export interface NavProps {
  className?: string;
}

const OPEN_APP_URL = 'https://app.opspilott.com';

export function Nav({ className }: NavProps): React.ReactElement {
  const onJump = (id: string) => (): void => scrollToId(id);

  return (
    <header
      className={cn(
        'sticky top-0 z-50 border-b bg-background/80 backdrop-blur supports-[backdrop-filter]:bg-background/60',
        className
      )}
    >
      <Container className="flex h-16 items-center justify-between gap-4">
        <a href="/" className="flex items-center gap-2 font-semibold tracking-tight text-foreground">
          <span className="inline-flex h-8 w-8 items-center justify-center rounded-md bg-primary text-primary-foreground">
            OP
          </span>
          <span>OpsPilott</span>
        </a>

        <nav className="hidden items-center gap-6 text-sm text-muted-foreground md:flex" aria-label="Primary">
          <button type="button" className="hover:text-foreground" onClick={onJump('features')}>
            Product
          </button>
          <button type="button" className="hover:text-foreground" onClick={onJump('why')}>
            Why OpsPilott
          </button>
          <button type="button" className="hover:text-foreground" onClick={onJump('who')}>
            Who it’s for
          </button>
          <button type="button" className="hover:text-foreground" onClick={onJump('contact')}>
            Contact
          </button>
        </nav>

        <div className="flex items-center gap-2">
          <Button asChild>
            <a href={OPEN_APP_URL} target="_blank" rel="noreferrer">
              Open App
            </a>
          </Button>
        </div>
      </Container>
    </header>
  );
}

